import { createContext } from 'react';

const githubContext = createContext();

export default githubContext;



// WEBPACK FOOTER //
// ./src/context/github/githubContext.js